// 9fbef606107a605d69c0edbcd8029e5d

const drawSnow = (ctx, size, colors, isCustomColorOverride) => {
  ctx.beginPath();
  ctx.arc(size, size, size / 2, 0, Math.PI * 2);
  ctx.fillStyle = isCustomColorOverride ? colors : '#ffffff';
  ctx.fill();
};

export default drawSnow;
